import { Component, Input } from '@angular/core';
import { MRulesGroup } from './data-source';

@Component({
  selector: 'm-rules-group',
  template: `
    <div class="m-rules-group">
      <nz-space class="m-rules-group-item">
        <nz-form-item *nzSpaceItem>
          <nz-form-control
            [nzValidateStatus]="group.nameValidator(group).status"
            [nzErrorTip]="group.nameValidator(group).text"
            [nzWarningTip]="group.nameValidator(group).text"
            [nzSuccessTip]="group.nameValidator(group).text"
            [nzValidatingTip]="group.nameValidator(group).text"
          >
            <input nz-input class="m-rules-group-text-name" [(ngModel)]="group.name" [placeholder]="group.name" />
          </nz-form-control>
        </nz-form-item>
        <nz-select *nzSpaceItem [(ngModel)]="group.option">
          <nz-option *ngFor="let o of group.options" [nzValue]="o.value" [nzLabel]="o.label"></nz-option>
        </nz-select>
        <nz-form-item *nzSpaceItem>
          <nz-form-control
            [nzValidateStatus]="group.valueValidator(group).status"
            [nzErrorTip]="group.valueValidator(group).text"
            [nzWarningTip]="group.valueValidator(group).text"
            [nzSuccessTip]="group.valueValidator(group).text"
            [nzValidatingTip]="group.valueValidator(group).text"
          >
            <input nz-input class="m-rules-group-text-value" [(ngModel)]="group.value" />
          </nz-form-control>
        </nz-form-item>
      </nz-space>
      <div class="m-rules-group-children">
        <ng-content></ng-content>
      </div>
    </div>
  `
})
export class MRulesGroupComponent {
  @Input() group: MRulesGroup = new MRulesGroup({});
}
